
export default async function mergePdf(uname, token, json) {
    return new Promise(function (resolve, reject) {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        
        var raw = JSON.stringify(json);
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow'
        };
        
        fetch("https://fixmeeting.eu/fixmeeting-pdfs/api/merge-pdf", requestOptions)
          .then(response => response.text())
          .then(result => resolve(result))
          .catch(error => console.log('error', error)); 
    });
}
